import { Action } from 'redux';

export const CREATE_PACIENTE_REQUEST = 'CREATE_PACIENTE_REQUEST';
export const CREATE_PACIENTE_SUCCESS = 'CREATE_PACIENTE_SUCCESS';
export const CREATE_PACIENTE_FAILURE = 'CREATE_PACIENTE_FAILURE';

export const TOGGLE_VISTA_PACIENTES = 'TOGGLE_VISTA_PACIENTES';

export const FETCH_PACIENTES_EMPRESA_REQUEST = 'FETCH_PACIENTES_EMPRESA_REQUEST';
export const FETCH_PACIENTES_EMPRESA_SUCCESS = 'FETCH_PACIENTES_EMPRESA_SUCCESS';
export const FETCH_PACIENTES_EMPRESA_FAILURE = 'FETCH_PACIENTES_EMPRESA_FAILURE';


export const FETCH_PACIENTES_REQUEST = 'FETCH_PACIENTES_REQUEST';
export const FETCH_PACIENTES_SUCCESS = 'FETCH_PACIENTES_SUCCESS';
export const FETCH_PACIENTES_FAILURE = 'FETCH_PACIENTES_FAILURE';
export const SET_PACIENTES_PAGE = 'SET_PACIENTES_PAGE';
export const SET_PACIENTES_LIMIT = 'SET_PACIENTES_LIMIT';

export const UPDATE_PACIENTE_REQUEST = 'UPDATE_PACIENTE_REQUEST';
export const UPDATE_PACIENTE_SUCCESS = 'UPDATE_PACIENTE_SUCCESS';
export const UPDATE_PACIENTE_FAILURE = 'UPDATE_PACIENTE_FAILURE';

export const DELETE_PACIENTE_REQUEST = 'DELETE_PACIENTE_REQUEST';
export const DELETE_PACIENTE_SUCCESS = 'DELETE_PACIENTE_SUCCESS';
export const DELETE_PACIENTE_FAILURE = 'DELETE_PACIENTE_FAILURE';

export interface CreatePacienteRequestAction extends Action<typeof CREATE_PACIENTE_REQUEST> {
  type: typeof CREATE_PACIENTE_REQUEST;
}

export interface CreatePacienteSuccessAction extends Action<typeof CREATE_PACIENTE_SUCCESS> {
  type: typeof CREATE_PACIENTE_SUCCESS;
  payload: any;
}

export interface CreatePacienteFailureAction extends Action<typeof CREATE_PACIENTE_FAILURE> {
  type: typeof CREATE_PACIENTE_FAILURE;
  payload: string;
}

export interface FetchPacientesRequestAction extends Action<typeof FETCH_PACIENTES_REQUEST> {
  type: typeof FETCH_PACIENTES_REQUEST;
}

export interface FetchPacientesSuccessAction extends Action<typeof FETCH_PACIENTES_SUCCESS> {
  type: typeof FETCH_PACIENTES_SUCCESS;
  payload: {
    data: any[];
    meta: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export interface FetchPacientesFailureAction extends Action<typeof FETCH_PACIENTES_FAILURE> {
  type: typeof FETCH_PACIENTES_FAILURE;
  payload: string;
}

export interface SetPacientesPageAction extends Action<typeof SET_PACIENTES_PAGE> {
  type: typeof SET_PACIENTES_PAGE;
  payload: number;
}

export interface SetPacientesLimitAction extends Action<typeof SET_PACIENTES_LIMIT> {
  type: typeof SET_PACIENTES_LIMIT;
  payload: number;
}

export interface UpdatePacienteRequestAction extends Action<typeof UPDATE_PACIENTE_REQUEST> {
  type: typeof UPDATE_PACIENTE_REQUEST;
}

export interface UpdatePacienteSuccessAction extends Action<typeof UPDATE_PACIENTE_SUCCESS> {
  type: typeof UPDATE_PACIENTE_SUCCESS;
  payload: any;
}

export interface UpdatePacienteFailureAction extends Action<typeof UPDATE_PACIENTE_FAILURE> {
  type: typeof UPDATE_PACIENTE_FAILURE;
  payload: string;
}

export interface DeletePacienteRequestAction extends Action<typeof DELETE_PACIENTE_REQUEST> {
  type: typeof DELETE_PACIENTE_REQUEST;
}

export interface DeletePacienteSuccessAction extends Action<typeof DELETE_PACIENTE_SUCCESS> {
  type: typeof DELETE_PACIENTE_SUCCESS;
  payload: string; 
}

export interface DeletePacienteFailureAction extends Action<typeof DELETE_PACIENTE_FAILURE> {
  type: typeof DELETE_PACIENTE_FAILURE;
  payload: string;
}

export type PacientesActionTypes =
  | CreatePacienteRequestAction
  | CreatePacienteSuccessAction
  | CreatePacienteFailureAction
  | FetchPacientesRequestAction
  | FetchPacientesSuccessAction
  | FetchPacientesFailureAction
  | SetPacientesPageAction
  | SetPacientesLimitAction
  | UpdatePacienteRequestAction
  | UpdatePacienteSuccessAction
  | UpdatePacienteFailureAction
  | DeletePacienteRequestAction
  | DeletePacienteSuccessAction
  | DeletePacienteFailureAction;